import React from 'react';
import { withTranslation, Trans } from 'react-i18next';
import { Text, List, ListItem } from '@paygreen/paygreen-ui';

const CarbonEqTypesList = ({ t }) => {
    const typeOfCarbonEq = ['total', 'otherVendor'];

    return (
        <List listStyle="icon">
            {typeOfCarbonEq.map((element, index) => (
                <ListItem bulletSize="xs" key={index}>
                    <Text textSize="xs" colorWab="grey50">
                        <Trans
                            i18nKey={`offsets.explanationModal.carbonEq.${element}.carbonTypeMessage`}
                        >
                            ...
                            <Text
                                htmlTag="strong"
                                textSize="xs"
                                colorWab="grey50"
                            >
                                {{
                                    carbonName: t(
                                        `offsets.explanationModal.carbonEq.${element}.carbonName`,
                                    ),
                                }}
                            </Text>
                            ...
                            <Text
                                htmlTag="strong"
                                textSize="xs"
                                colorWab="grey50"
                            >
                                {{
                                    carbonExplanation: t(
                                        `offsets.explanationModal.carbonEq.${element}.carbonExplanation`,
                                    ),
                                }}
                            </Text>
                            ...
                        </Trans>
                    </Text>
                </ListItem>
            ))}
        </List>
    );
};

export default withTranslation('common')(CarbonEqTypesList);
